import React from "react";

const URL_REGEX = /https?:\/\/[^\s<>"'`]+/g;

/**
 * Linkifies a single line of text (no newlines).
 * Returns an array of strings and <a> elements.
 */
function linkifyLine(line, lineIndex) {
  const parts = [];
  const regex = new RegExp(URL_REGEX.source, "g");
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(line)) !== null) {
    if (match.index > lastIndex) {
      parts.push(line.slice(lastIndex, match.index));
    }
    const url = match[0];
    parts.push(
      <a
        key={`${lineIndex}-${match.index}`}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={e => e.stopPropagation()}
        style={{ color: "#d0521f", wordBreak: "break-all" }}
      >
        {url}
      </a>
    );
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < line.length) {
    parts.push(line.slice(lastIndex));
  }

  return parts;
}

/**
 * Renders text with:
 *  - URLs converted to clickable <a> tags (open in new tab)
 *  - Newlines (\n) preserved as <br> elements so multi-line descriptions
 *    display exactly as typed.
 *
 * @param {string} text - The text to render.
 * @param {object} props - Any extra props forwarded to the wrapping <span>.
 */
function LinkifiedText({ text, ...props }) {
  if (!text) return null;

  const lines = text.split("\n");
  const nodes = [];

  lines.forEach((line, i) => {
    linkifyLine(line, i).forEach(part => nodes.push(part));
    // Add a <br> after every line except the last
    if (i < lines.length - 1) {
      nodes.push(<br key={`br-${i}`} />);
    }
  });

  return <span {...props}>{nodes}</span>;
}

export default LinkifiedText;
